document.addEventListener('DOMContentLoaded', function() {
    const siteHeader = document.querySelector('.site-header');
    let lastScrollTop = 0;
    let scrollThreshold = 100;
    let isHeaderVisible = true;

    // --- Subnav top position ---
    function updateSubnavTop() {
      const container = document.querySelector('.site-header-container');
      if (!container) return;
      const bottom = container.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--subnav-top', bottom + 'px');
    }

    updateSubnavTop();
    window.addEventListener('resize', updateSubnavTop);
  
    window.addEventListener('scroll', function() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop <= 0) {
            siteHeader.classList.remove('header-hidden');
            siteHeader.classList.remove('header-scrolled');
            isHeaderVisible = true;
            updateSubnavTop();
            return;
        }
  
        if (scrollTop > 50) {
            siteHeader.classList.add('header-scrolled');
        } else {
            siteHeader.classList.remove('header-scrolled');
        }
  
        if (Math.abs(scrollTop - lastScrollTop) < 5) {
            return;
        }
  
        if (window.innerWidth < 1160) {
            if (scrollTop > lastScrollTop && scrollTop > scrollThreshold) {
                if (isHeaderVisible) {
                    siteHeader.classList.add('header-hidden');
                    isHeaderVisible = false;
                }
            } else if (scrollTop < lastScrollTop) {
                if (!isHeaderVisible) {
                    siteHeader.classList.remove('header-hidden');
                    isHeaderVisible = true;
                }
            }
        } else {
            siteHeader.classList.remove('header-hidden');
            isHeaderVisible = true;
        }

        updateSubnavTop();
        lastScrollTop = scrollTop;
    });

    // Desktop navigation - click to open, auto-close on mouse leave
    const navItems = document.querySelectorAll('.site-header-container__nav-item.has-subnav');
    
    navItems.forEach(function(item) {
        const link = item.querySelector('.site-header-container__nav-link');
        const subnav = item.querySelector('.subnav');
        let isMouseOverItem = false;
        let isMouseOverSubnav = false;
        
        if (link && subnav) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                const isActive = item.classList.contains('subnav-active');
                
                navItems.forEach(function(otherItem) {
                    if (otherItem !== item) {
                        otherItem.classList.remove('subnav-active');
                    }
                });
                
                if (isActive) {
                    item.classList.remove('subnav-active');
                } else {
                    updateSubnavTop();
                    item.classList.add('subnav-active');
                }
            });
            
            item.addEventListener('mouseenter', function() {
                isMouseOverItem = true;
            });
            
            item.addEventListener('mouseleave', function() {
                isMouseOverItem = false;
                setTimeout(function() {
                    if (!isMouseOverItem && !isMouseOverSubnav) {
                        item.classList.remove('subnav-active');
                    }
                }, 100);
            });
            
            subnav.addEventListener('mouseenter', function() {
                isMouseOverSubnav = true;
            });
            
            subnav.addEventListener('mouseleave', function() {
                isMouseOverSubnav = false;
                setTimeout(function() {
                    if (!isMouseOverItem && !isMouseOverSubnav) {
                        item.classList.remove('subnav-active');
                    }
                }, 100);
            });
        }
    });
    
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.site-header-container__nav-item.has-subnav')) {
            navItems.forEach(function(item) {
                item.classList.remove('subnav-active');
            });
        }
    });
  
    const hamburgerBtn = document.getElementById('hamburger-btn');
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileMenuClose = document.getElementById('mobile-menu-close');
    const body = document.body;
  
    if (hamburgerBtn) {
        hamburgerBtn.addEventListener('click', function() {
            mobileMenu.classList.add('active');
            body.classList.add('mobile-menu-open');
        });
    }
  
    if (mobileMenuClose) {
        mobileMenuClose.addEventListener('click', function() {
            mobileMenu.classList.remove('active');
            body.classList.remove('mobile-menu-open');
        });
    }

    if (mobileMenu) {
        mobileMenu.addEventListener('click', function(e) {
            if (e.target === mobileMenu) {
                mobileMenu.classList.remove('active');
                body.classList.remove('mobile-menu-open');
            }
        });
    }
  
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('active')) {
            mobileMenu.classList.remove('active');
            body.classList.remove('mobile-menu-open');
        }
    });
  
    window.addEventListener('resize', function() {
        if (window.innerWidth >= 1160 && mobileMenu) {
            mobileMenu.classList.remove('active');
            body.classList.remove('mobile-menu-open');
        }
    });
  
    const mobileNavItems = document.querySelectorAll('.mobile-nav-item.has-subnav');
    
    mobileNavItems.forEach(function(item) {
        const header = item.querySelector('.mobile-nav-header');
        const subnav = item.querySelector('.mobile-subnav');
        const arrow = item.querySelector('.mobile-nav-arrow');
        
        if (header) {
            header.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                const allItems = document.querySelectorAll('.mobile-nav-item');
                allItems.forEach(function(otherItem) {
                    if (otherItem !== item) {
                        otherItem.classList.remove('active');
                        const otherSubnav = otherItem.querySelector('.mobile-subnav');
                        const otherArrow = otherItem.querySelector('.mobile-nav-arrow');
                        if (otherSubnav) {
                            otherSubnav.style.maxHeight = '0';
                        }
                        if (otherArrow) {
                            otherArrow.textContent = '+';
                            otherArrow.style.transform = 'rotate(0deg)';
                        }
                    }
                });
                
                item.classList.toggle('active');
                
                if (item.classList.contains('active')) {
                    subnav.style.maxHeight = subnav.scrollHeight + 'px';
                    arrow.textContent = '−';
                    arrow.style.transform = 'rotate(180deg)';
                } else {
                    subnav.style.maxHeight = '0';
                    arrow.textContent = '+';
                    arrow.style.transform = 'rotate(0deg)';
                }
            });
        }
    });
});